import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { PagedCollectionParams } from '../../models/paged-collection-params';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { driverGroupPagedCollectionSchema } from './schemas/driver-group-paged-collection';

export function getDriverGroups(params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.driverGroupsUrl}?${
    params ? params.urlParams : ''
  }`;
  return fromFetch(
    new Request(requestUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(driverGroupPagedCollectionSchema));
}
